import Clarity from "@microsoft/clarity"

export function initClarity() {
  const projectId = document.querySelector('meta[name="spark-clarity-project-id"]')?.content
  if (!projectId) return

  window.Clarity = Clarity
  Clarity.init(projectId)
}

export function identifyClarityUser() {
  if (!window.Clarity) return

  const userId = document.querySelector('meta[name="spark-clarity-user-id"]')?.content
  const sessionId = document.querySelector('meta[name="spark-clarity-session-id"]')?.content
  if (userId) {
    Clarity.identify(userId, sessionId)
  }
}
